<script setup lang="tsx">
import { Status, mapState, context } from "../../context/context";
import Page from "../base/Page.vue";
import ContentTopCenter from "../layout/ContentTopCenter.vue";
import IconStatus from "../icon/IconStatus.vue";
import CallPhone from "../widget/CallPhone.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Page, ContentTopCenter, IconStatus, CallPhone },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    status?: Status;
    title?: string;
    subtitle?: string;
  }>(),
  {}
);

const mappedState = mapState([
  "result.status",
  "result.title",
  "result.subtitle",
  "park.phone",
  "color.fontPattern",
  "color.fontTertiaryPattern"
]);

const status = props.status || mappedState["result.status"].value;
const title = props.title || mappedState["result.title"].value;
const subtitle = props.subtitle || mappedState["result.subtitle"].value;
</script>

<template>
  <Page class="result">
    <ContentTopCenter class="result-content">
      <div class="result-img">
        <IconStatus
          :status="status"
          mode="fullfill"
        ></IconStatus>
      </div>
      <div
        v-if="title"
        class="result-title"
        :style="{
          color: mappedState['color.fontPattern'].value
        }"
      >
        {{ title }}
      </div>
      <div
        v-if="subtitle"
        class="result-subtitle"
        :style="{
          color: mappedState['color.fontTertiaryPattern'].value
        }"
      >
        {{ subtitle }}
      </div>
    </ContentTopCenter>

    <template #footer>
      <CallPhone
        class="result-bottom"
        :phone="mappedState['park.phone'].value || context.static.hotline"
      ></CallPhone>
    </template>
  </Page>
</template>

<style scoped>
.result-content {
  padding: 40px var(--yz-padding-horizontal, 15px) 0;
}
.result-img {
  width: 64px;
}
.result-title {
  font-size: 20px;
  margin-top: 16px;
  font-weight: bold;
  text-align: center;
}
.result-subtitle {
  font-size: 14px;
  margin-top: 7px;
  text-align: center;
}
.result-bottom {
  padding-bottom: var(--yz-padding-vertical-double, 20px);
}
</style>
